import * as React from "react";
import { UsernameLoginWidget } from "user-management/src/components/usernameLoginWidget";
import { useHistory } from "react-router-dom";
import { signOut } from "user-management/src/cognito/kahunUserAuth";
import { makeStyles } from "@mui/styles";
import { CLINIC_MANAGE_URL } from "./clinicSettings/clinicUrls";
import { useClinicUserContext } from "./clinicUserContext";

//region [[ Styles ]]

const useStyles = makeStyles({
  loginWidget: (props: { absolute: boolean }) =>
    props.absolute && {
      position: "absolute",
      right: "10px",
      top: "10px",
    },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicLoginWidgetProps {
  absolute?: boolean;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicLoginWidget = ({ ...props }: ClinicLoginWidgetProps) => {
  const history = useHistory();
  const clinicUser = useClinicUserContext();
  const classes = useStyles({ absolute: props.absolute });
  const onLogout = () => {
    clinicUser && clinicUser.clearUser();
    signOut();
    history.push(`${CLINIC_MANAGE_URL}/login`);
  };

  return (
    <div className={classes.loginWidget}>
      <UsernameLoginWidget
        onLogoutClicked={onLogout}
        onLoginClicked={null}
        isUserLoggedIn
        className={props.className}
      />
    </div>
  );
};
